import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/Index.vue'

import Header from './components/modules/headerSection.vue'
import Footer from './components/modules/footerSection.vue'

Vue.use(Router)

const originalPush = Router.prototype.push

const originalReplace = Router.prototype.replace

Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
Router.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch(err => err)
}

const routes = [
  // 停機公告頁
  // {
  //   path: '/*',
  //   name: 'Downtime',
  //   components: {
  //     default: () => import('./views/Downtime.vue'),
  //     nav: Header,
  //     footer: Footer
  //   }
  // },
  // 首頁
  {
    path: '/',
    name: 'index',
    components: {
      default: Index,
      nav: Header,
      footer: Footer
    },
    meta: { gtm: 'index' }
  },
  // 搜尋結果
  {
    path: '/search/',
    name: 'SearchResult',
    components: {
      default: () => import('./views/SearchResult.vue'),
      nav: Header,
      footer: Footer
    },
    meta: { gtm: 'SearchResult' }
  },
  {
    path: '/forgotPwd',
    name: 'forgotPwd',
    components: {
      default: () => import('./views/ForgotPwd.vue'),
      nav: Header,
      footer: Footer
    },
    meta: {
      requiresAuth: false,
      title: '忘記密碼',
      gtm: 'login'
    }
  },
  {
    path: '/deleteUser',
    name: 'deleteUser',
    components: {
      default: () => import('./views/DeleteUser.vue'),
      nav: Header,
      footer: Footer
    },
    meta: {
      requiresAuth: false,
      title: '忘記密碼',
      gtm: 'login'
    }
  },
  // 登入
  {
    path: '/login',
    name: 'login',
    components: {
      default: () => import('./views/Login.vue'),
      nav: Header,
      footer: Footer
    },
    meta: {
      requiresAuth: false,
      title: '會員登入',
      gtm: 'login'
    }
  },
  // 註冊
  {
    path: '/register',
    name: 'register',
    components: {
      default: () => import('./views/Register.vue'),
      nav: Header,
      footer: Footer
    },
    meta: {
      requiresAuth: false,
      title: '會員註冊',
      gtm: 'register'
    }
  },
  // 註冊
  {
    path: '/register_success',
    name: 'jump',
    components: {
      default: () => import('./views/Jump.vue'),
      nav: Header,
      footer: Footer
    },
    meta: {
      requiresAuth: false,
      title: '會員註冊',
      gtm: 'register'
    }
  },
  {
    path: '/login_FB',
    name: 'FBlogin',
    components: {
      default: () => import('./views/FBLogin.vue'),
      nav: Header,
      footer: Footer
    },
    meta: {
      requiresAuth: false,
      title: '會員登入',
      gtm: 'FBlogin'
    }
  },
  // 商品相關頁面
  {
    path: '/products',
    name: 'ListView',
    components: {
      default: () => import('./views/listView/Layout.vue'),
      nav: Header,
      footer: Footer
    },
    children: [
      {
        // 雜誌列表
        path: 'newest-magazine',
        name: 'magazine',
        component: () => import('./views/listView/CurrentMagazine'),
        meta: { gtm: 'magazine' }
      },
      {
        // 雜誌各刊
        path: 'newest-magazine/:class',
        name: 'magazineIntro',
        component: () => import('./views/listView/MagazineIntro')
      },
      {
        // 商品列表
        path: ':category',
        name: 'productsList',
        component: () => import('./views/listView/List.vue')
      },
      {
        // 活動
        path: ':category?/sale/:tag?',
        name: 'sale',
        component: () => import('./views/listView/Sale.vue')
      },
      {
        // 詳細頁
        path: '/:category?/detail/:id?',
        name: 'detail',
        component: () => import('./views/listView/Detail.vue')
      },
      {
        // 預覽
        path: '/:category?/preview/:id?',
        name: 'previewMagazine',
        component: () => import('./views/listView/Detail.vue')
      }
    ]
  },
  // 購物車
  {
    path: '/checkout/:step?',
    name: 'checkout',
    components: {
      default: () => import('./views/Checkout.vue'),
      nav: Header,
      footer: Footer
    },
    meta: {
      requiresAuth: false,
      title: '購物車',
      gtm: 'checkout'
    }
  },
  // 收藏
  {
    path: '/favorite',
    name: 'favorite',
    components: {
      default: () => import('./views/user/WishList.vue'),
      nav: Header,
      footer: Footer
    },
    meta: { requiresAuth: true, gtm: 'favorite' }
  },
  // 會員相關資料
  {
    path: '/user',
    components: {
      default: () => import('./views/user/Layout.vue'),
      nav: Header,
      footer: Footer
    },
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'manage',
        component: () => import('./views/user/Manage.vue'),
        meta: { gtm: 'manage' }
      },
      {
        path: 'order',
        name: 'order',
        component: () => import('./views/user/OrderList.vue'),
        meta: { gtm: 'OrderList' }
      },
      {
        path: 'orderdetail/:id',
        name: 'orderdetail',
        component: () => import('./views/user/OrderDetail.vue'),
        meta: { gtm: 'orderdetail' }
      },
      {
        path: 'account',
        name: 'account',
        component: () => import('./views/user/Account.vue'),
        meta: { gtm: 'account' }
      },
      {
        path: 'common-address',
        name: 'commonAddress',
        component: () => import('./views/user/ShippingAddress.vue'),
        meta: { gtm: 'commonAddress' }
      }
    ]
  },
  // 公司相關頁面
  {
    path: '/company',
    name: 'company',
    components: {
      default: () => import('./views/company/Layout.vue'),
      nav: Header,
      footer: Footer
    },
    children: [
      {
        path: 'about',
        name: 'about',
        component: () => import('./views/company/About.vue'),
        meta: {
          requiresAuth: false,
          title: '品牌故事'
        }
      },
      {
        path: 'contract-revise',
        name: 'contract-revise',
        component: () => import('./views/company/ContractRevise.vue'),
        meta: {
          requiresAuth: false,
          title: '批改網服務契約'
        }
      },
      {
        path: 'contract-LTTC',
        name: 'contract-lttc',
        component: () => import('./views/company/ContractLTTC.vue'),
        meta: {
          requiresAuth: false,
          title: 'LTTC英文檢定練習服務契約'
        }
      },
      {
        path: 'contract-LiveTalk',
        name: 'contract-livetalk',
        component: () => import('./views/company/ContractLiveTalk.vue'),
        meta: {
          requiresAuth: false,
          title: 'LiveTalk網際網路服務契約'
        }
      },
      {
        path: 'policy',
        name: 'policy',
        component: () => import('./views/company/Policy.vue'),
        meta: {
          requiresAuth: false,
          title: '服務條款'
        }
      },
      {
        path: 'privacy',
        name: 'privacy',
        component: () => import('./views/company/Privacy.vue'),
        meta: {
          requiresAuth: false,
          title: '隱私權政策'
        }
      },
      {
        path: 'information',
        name: 'information',
        component: () => import('./views/company/Information.vue'),
        meta: {
          requiresAuth: false,
          title: '公司資訊'
        }
      },
      {
        path: 'contact',
        name: 'contact',
        component: () => import('./views/company/Contact.vue'),
        meta: {
          requiresAuth: false,
          title: '業務合作洽談'
        }
      },
      {
        path: 'connect',
        name: 'connect',
        component: () => import('./views/company/Connect.vue'),
        meta: {
          requiresAuth: false,
          title: '客服信箱'
        }
      },
      {
        path: 'AI',
        name: 'AI',
        component: () => import('./views/company/AI.vue'),
        meta: {
          requiresAuth: false,
          title: '免責聲明'
        }
      },
      // QA
      {
        path: 'service/:id?',
        name: 'service',
        component: () => import('./views/company/Service.vue'),
        meta: {
          requiresAuth: false,
          title: '常見問題'
        }
      },
      // 雜誌轉換
      {
        path: 'magazineTransform',
        name: 'magazineSendBack',
        component: () => import('./views/company/MagTransform.vue')
      },
      {
        path: 'subscriberNumbering',
        name: 'subscriberNumbering',
        component: () => import('./views/user/SubscriberNumbering.vue')
      }
    ]
  },
  // 主題專欄
  {
    path: '/topic',
    name: 'topic',
    components: {
      default: () => import('./views/article/Layout.vue'),
      nav: Header,
      footer: Footer
    },
    children: [
      {
        path: 'list/:topicCategory?',
        name: 'topicList',
        component: () => import('./views/article/ArticleList.vue')
      },
      {
        path: 'article/:id?',
        name: 'topicDetail',
        component: () => import('./views/article/ArticleContent.vue')
      }
    ]
  },
  // 點讀筆
  {
    path: '/smartPen',
    name: 'pen',
    components: {
      default: () => import('./views/readingPen/Layout.vue'),
      nav: Header,
      footer: Footer
    },
    children: [
      {
        path: 'index',
        name: 'readpen',
        component: () => import('./views/readingPen/LandingPage.vue'),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: 'intro',
        name: 'intro',
        component: () => import('./views/readingPen/IntroPen2.vue'),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: 'download',
        name: 'download',
        component: () => import('./views/readingPen/Download.vue'),
        meta: {
          requiresAuth: false
        }
      }
    ]
  },
  {
    path: '/web/smartPen/intro',
    name: 'intro_new',
    components: {
      default: () => import('./views/readingPen/IntroPen3.vue'),
      nav: Header,
      footer: Footer
    },
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/web/smartPen2/intro',
    name: 'intro_new2',
    components: {
      default: () => import('./views/readingPen/IntroPen2.vue'),
      nav: Header,
      footer: Footer
    },
    meta: {
      requiresAuth: false
    }
  },
  // 數位學習
  {
    path: '/learning',
    name: 'learning',
    components: {
      default: () => import('./views/DigitalLearn.vue'),
      nav: Header,
      footer: Footer
    },
    meta: {
      requiresAuth: false
    }
  },
  // 電子報
  {
    path: '/unsubscribe',
    name: 'unsubscribe',
    components: {
      default: () => import('./views/company/Unsubscribe.vue'),
      nav: Header,
      footer: Footer
    },
    meta: {
      requiresAuth: false,
      title: '取消訂閱電子報'
    }
  },
  // 修改密碼
  {
    path: '/reset_password',
    name: 'ResetPassword',
    components: {
      default: () => import('./views/company/ResetPassword.vue'),
      nav: Header,
      footer: Footer
    },
    meta: {
      requiresAuth: false,
      title: '修改密碼'
    }
  },
  // 信箱驗證
  {
    path: '/validate/subscribe/:email/:token/:action',
    name: 'validate',
    components: {
      default: () => import('./views/company/emailVerification.vue'),
      nav: Header,
      footer: Footer
    },
    meta: {
      requiresAuth: false,
      title: '信箱驗證'
    }
  },
  // 每日一句
  {
    path: '/daily-sentence',
    name: 'dailySentence',
    components: {
      default: () => import('./views/company/DailySentence.vue'),
      nav: Header,
      footer: Footer
    },
    meta: {
      requiresAuth: false,
      title: '每日一句'
    }
  },
  // {
  //   path: '/liveTalk',
  //   name: 'liveTalk',
  //   component: () => import('./views/LiveTalk.vue'),
  //   meta: {
  //     requiresAuth: false,
  //     title: 'LiveTalk線上真人口說教室',
  //     gtm: 'liveTalk'
  //   }
  // },
  {
    path: '/group_buying/',
    name: 'groupBuying',
    components: {
      default: () => import('./views/GroupBuying.vue'),
      nav: Header,
      footer: Footer
    },
    children: [
      {
        // 商品列表
        path: ':tag?',
        name: 'groupBuyingTag',
        component: () => import('./views/listView/Sale.vue')
      }
    ],
    meta: {
      requiresAuth: false,
      title: '團購'
    }
  },
  // Events
  {
    path: '/event',
    name: 'event',
    component: () => import('./views/events/Layout.vue'),
    meta: {
      requiresAuth: false,
      title: 'event',
      gtm: 'event'
    },
    children: [
      {
        path: 'SamsungP610',
        name: 'samsungP610',
        component: () => import('./views/events/2020/Samsung.vue')
      },
      {
        path: 'bookFair2020',
        name: 'bookFair2020',
        component: () => import('./views/events/2020/BookFair2020.vue')
      },
      {
        path: 'SinglesDay2020',
        name: 'SinglesDay2020',
        component: () => import('./views/events/2020/SinglesDay2020.vue')
      },
      {
        path: '2020Double12',
        name: '2020Double12',
        component: () => import('./views/events/2020/Double12_2020.vue')
      },
      {
        path: 'ACD18',
        name: 'ACD18',
        component: () => import('./views/events/2021/ACD18.vue')
      },
      {
        path: 'event202108',
        name: 'event202108',
        component: () => import('./views/events/2021/event202108.vue')
      },
      {
        path: 'mzfestival',
        name: 'mzfestival',
        component: () => import('./views/events/2021/Mzfestival.vue')
      },
      {
        path: 'FUNHIW',
        name: 'FUNHIW',
        component: () => import('./views/events/2021/FUNHIW.vue')
      },
      {
        path: 'Double10_2021',
        name: 'double10_2021',
        component: () => import('./views/events/2021/Double10_2021.vue')
      },
      {
        path: 'Double11_2021',
        name: 'Double11_2021',
        component: () => import('./views/events/2021/Double11_2021.vue')
      },
      {
        path: 'Double12_2021',
        name: 'Double12_2021',
        component: () => import('./views/events/2021/Double12_2021.vue')
      },
      {
        path: 'NewYear_2022',
        name: 'Jan_2022',
        component: () => import('./views/events/2022/Jan_2022.vue')
      },
      {
        path: 'BookFair_2022',
        name: 'Feb_2022',
        component: () => import('./views/events/2022/Feb_2022.vue')
      },
      {
        path: 'Children_BookFair_2022',
        name: '',
        component: () => import('./views/events/2022/April_2022.vue')
      },
      {
        path: 'June2022',
        name: 'May2022',
        component: () => import('./views/events/2022/May_2022.vue')
      },
      {
        path: 'JULY2022',
        name: 'July2022',
        component: () => import('./views/events/2022/July_2022.vue')
      },
      {
        path: 'AUG2022',
        name: 'AUGUST2022',
        component: () => import('./views/events/2022/August_2022.vue')
      },
      {
        path: 'OCTOBER2022',
        name: 'OCTOBER2022',
        component: () => import('./views/events/2022/October_2022.vue')
      },
      {
        path: 'double11_2022',
        name: 'November2022',
        component: () => import('./views/events/2022/November_2022.vue')
      },
      {
        path: 'December_2022',
        name: 'December2022',
        component: () => import('./views/events/2022/December_2022.vue')
      },
      {
        path: 'liveabcxwordup',
        name: 'liveabcxwordup',
        component: () => import('./views/events/2022/liveabcxwordup.vue')
      },
      {
        path: 'springbookfair2023',
        name: 'springbookfair2023',
        component: () => import('./views/events/2023/202301.vue')
      },
      {
        path: 'April2023',
        name: 'April2023',
        component: () => import('./views/events/2023/202304.vue')
      },
      {
        path: 'May2023',
        name: 'May2023',
        component: () => import('./views/events/2023/202305.vue')
      },
      {
        path: 'June2023',
        name: 'June2023',
        component: () => import('./views/events/2023/202306.vue')
      },
      {
        path: 'July2023',
        name: 'July2023',
        component: () => import('./views/events/2023/202307.vue')
      },
      {
        path: 'Sep2023',
        name: 'Sep2023',
        component: () => import('./views/events/2023/202309.vue')
      },
      {
        path: 'Oct2023',
        name: 'Oct2023',
        component: () => import('./views/events/2023/202310.vue')
      },
      {
        path: 'Nov2023',
        name: 'Nov2023',
        component: () => import('./views/events/2023/202311.vue')
      },
      {
        path: 'Dec2023',
        name: 'Dec2023',
        component: () => import('./views/events/2023/202312.vue')
      },
      {
        path: 'Jan2024',
        name: 'Jan2024',
        component: () => import('./views/events/2024/202401.vue')
      },
      {
        path: 'Feb2024',
        name: 'Feb2024',
        component: () => import('./views/events/2024/202402.vue')
      },
      {
        path: 'Mar2024',
        name: 'Mar2024',
        component: () => import('./views/events/2024/202403.vue')
      },
      {
        path: 'April2024',
        name: 'April2024',
        component: () => import('./views/events/2024/202404.vue')
      },
      {
        path: 'May2024',
        name: 'May2024',
        component: () => import('./views/events/2024/202405.vue')
      },
      {
        path: 'shuwoon',
        name: 'shuwoon',
        component: () => import('./views/events/2024/shuwoon.vue')
      },
      {
        path: 'June2024',
        name: 'June2024',
        component: () => import('./views/events/2024/202406.vue')
      },
      {
        path: 'July2024',
        name: 'July2024',
        component: () => import('./views/events/2024/202407.vue')
      },
      {
        path: 'August2024',
        name: 'August2024',
        component: () => import('./views/events/2024/202408.vue')
      },
      {
        path: 'October2024',
        name: 'October2024',
        component: () => import('./views/events/2024/202410.vue')
      },
      {
        path: 'November2024',
        name: 'November2024',
        component: () => import('./views/events/2024/202411.vue')
      },
      {
        path: 'December2024',
        name: 'December2024',
        component: () => import('./views/events/2024/202412.vue')
      },
      {
        path: 'MBTI2024',
        name: 'MBTI2024',
        component: () => import('./views/events/2024/MBTI.vue')
      },
      {
        path: 'AI_assistant',
        name: 'AI_assistant',
        component: () => import('./views/events/2024/AI_assistant.vue')
      },
      {
        path: 'January2025',
        name: 'January2025',
        component: () => import('./views/events/2025/202501.vue')
      },
      {
        path: 'February2025',
        name: 'February2025',
        component: () => import('./views/events/2025/202502.vue')
      },
      {
        path: 'March2025',
        name: 'March2025',
        component: () => import('./views/events/2025/202503.vue')
      },
      {
        path: 'April2025',
        name: 'April2025',
        component: () => import('./views/events/2025/202504.vue')
      },
      {
        path: 'May2025',
        name: 'May2025',
        component: () => import('./views/events/2025/202505.vue')
      },
      {
        path: 'June2025',
        name: 'June2025',
        component: () => import('./views/events/2025/202506.vue')
      }
    ]
  },
  {
    path: '/events',
    name: 'events',
    component: () => import('./views/events/Layout.vue'),
    meta: {
      requiresAuth: false,
      title: 'events',
      gtm: 'events'
    },
    children: [
      {
        path: ':eventId',
        name: 'event_page',
        component: () => import('./views/events/page.vue')
      }
    ]
  },
  { path: '/:pathMatch(.*)*', name: 'not-found', component: () => import('./views/NotFoundPage.vue') }
]

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    window.scrollTo({ 'top': 0 })
    // return { x: 0, y: 0 }
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 500)
    })
  }
})

export default router
